import React from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Text } from '../text';

export const BreadcrumbSeparator = ({ className }: { className?: string }) => {
  return (
    <Text
      data-testid="breadcrumb-separator"
      aria-hidden
      className={clsx('text-text', 'mx-2', className)}
    >
      /
    </Text>
  );
};
